import React from 'react';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaImageSlider from 'marketing-website/components/modules/Media/MediaImageSlider';
import photosOne from 'marketing-website/configs/pages/features/design/photosOne.js';
import photosTwo from 'marketing-website/configs/pages/features/design/photosTwo.js';
import icons from 'marketing-website/configs/pages/features/design/icons.js';

export default function PhotosBlock() {
  return (
    <Spacing type="padding" size="xl" position="top">
      <PageWrap size="m">
        <HeadingBlock
          size="s"
          justifyContent="flex-start"
          title="Access millions of stock photos, icons and assets"
          copy={
            <span>
              Don't know where to start? Don't panic!
              <br />
              <br />
              We have a huge collection of pre-made assets, images and icons
              which will help you visualise your ideas and get you to your first
              design fast.
            </span>
          }
        />
      </PageWrap>
      <Spacing type="margin" size="xl" position="top">
        <MediaImageSlider
          firstBatch={photosOne}
          secondBatch={icons}
          thirdBatch={photosTwo}
        />
      </Spacing>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/design/PhotosBlock.js